import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { filter } from 'helpers/decorators'
import { Input, Select } from 'components/fields'
import { Module, FilterActions, Row, Col } from 'components/misc'
import { tasks as tasksApi } from 'redux/modules/api'
import { apiCodeLists } from 'helpers/decorators/api'

@injectIntl
@apiCodeLists(['consentDeliveryTypes', 'participantPaymentStates'])
@connect(
  ({ api }) => ({
    query: api.tasks.registrationParticipants.filter,
    count: api.tasks.registrationParticipants.count
  }),
  { setFilter: tasksApi.registrationParticipants.setRegistrationTasksFilter }
)
@filter({
  form: 'tasks-registrationParticipants-filter',
  persist: true
})
class ParticipantsFilter extends Component {
  static propTypes = {
    codeLists: PropTypes.object,
    intl: PropTypes.object
    // initialize: PropTypes.func.isRequired,
  }

  // componentDidMount() {
  //   this.props.initialize({
  //     'award_majorActivityNeeded@ne': null
  //   })
  // }

  render() {
    const { codeLists, intl } = this.props

    const emailOptions = [
      {
        value: 'true',
        label: intl.formatMessage({
          id: 'label.confirmed',
          defaultMessage: 'Confirmed'
        })
      },
      {
        value: 'false',
        label: intl.formatMessage({
          id: 'label.waiting',
          defaultMessage: 'Waiting'
        })
      }
    ]

    return (
      <Module verticallyNarrow primary>
        <Row alignItems="center" gutters inner>
          <Col flex="0 1 200px">
            <Input
              label="Search"
              intlKey="label.search"
              clearable
              name="participantPerson_firstName||participantPerson_lastName||participantPerson_email"
            />
          </Col>
          <Col flex="0 1 200px">
            <Select
              label="Email confirmation"
              intlKey="label.email_confirmation"
              name="participantPerson_isEmailConfirmed"
              options={emailOptions}
            />
          </Col>
          <Col flex="0 1 200px">
            <Select
              label="Parent approval"
              intlKey="label.parent_approval"
              name="award_consentDeliveryType_value"
              options={codeLists.consentDeliveryTypes.list}
            />
          </Col>
          <Col flex="0 1 200px">
            <Select
              label="Payment state"
              intlKey="label.payment_state"
              name="award_paymentState_value"
              options={codeLists.participantPaymentStates.list}
            />
          </Col>
          <Col flex="1 1 auto" alignSelf="flex-end" right>
            <FilterActions {...this.props} />
          </Col>
        </Row>
      </Module>
    )
  }
}

export default ParticipantsFilter
